import React, { useState, useEffect } from "react";
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import { socket, api } from "../api";
import TelebirrDepositModal from "./TelebirrDepositModal";
import CBEDepositModal from "./CBEDepositModal";
import { toast } from "react-toastify";
import axios from "axios";
import { parseJWT } from "../utils/jwtUtils";
import { useTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../components/navbar/Footer";

// console.log("user info : ", token);
export default function WalletPage() {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  const [activeTab, setActiveTab] = useState("deposit");
  const [balance, setBalance] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (userInfo?.phone) {
      //   console.log("Requesting balance for phone:", userInfo.phone);
      socket.emit("getBalance", { phone: userInfo.phone });

      socket.on("balanceResponse", (data) => {
        //  console.log("Received balance response from server:", data);
        if (data.success) {
          setBalance(data.balance);
        }
      });
    }

    return () => {
      socket.off("balanceResponse");
    };
  }, [userInfo?.phone]);

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        if (!userInfo?.referralCode) {
          setMessage("No referral code found for this user.");
          setLoading(false);
          return;
        }

        // ✅ Fetch referrals using shared API instance
        const { data } = await api.get(`/referrals/${userInfo.referralCode}`);
        // console.log("referral info : ", data);
        if (data.success) {
          setTotalIncome(data.totalIncome || 0);
          setMessage("");
        } else {
          setMessage(data.message || "Unable to load referral data.");
        }
      } catch (err) {
        //  console.error("⚠️ Failed to fetch referral history:", err);
        setMessage("0.00");
      } finally {
        setLoading(false);
      }
    };

    fetchReferrals();
  }, []);
  const { t: translate } = useTranslation(["WalletPage"]);
  return (
    <>
      {/* Navbar */}
      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-cyan-900 via-cyan-800 to-cyan-900">
        <Navbar2 />
      </div>
      <div className="min-h-screen bg-primary text-white flex flex-col lg:flex-row pt-32 md:pt-16">
        {/* Sidebar */}
        <div className="w-full lg:w-1/4 bg-[#134454] flex lg:flex-col justify-around lg:justify-start lg:pt-10 p-4 gap-4">
          <button
            onClick={() => setActiveTab("deposit")}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all font-serif ${
              activeTab === "deposit"
                ? "bg-[#0b1a1f]"
                : "bg-primary hover:bg-[#032c3aff]"
            }`}
          >
            💰 {translate("Deposit")}
          </button>
          <button
            onClick={() => setActiveTab("withdraw")}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all font-serif ${
              activeTab === "withdraw"
                ? "bg-[#0b1a1f]"
                : "bg-primary hover:bg-[#032c3aff]"
            }`}
          >
            💵 {translate("Withdraw")}
          </button>
          <button
            onClick={() => setActiveTab("history")}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all font-serif ${
              activeTab === "history"
                ? "bg-[#0b1a1f]"
                : "bg-primary hover:bg-[#032c3aff]"
            }`}
          >
            🔄 {translate("History")}
          </button>
        </div>

        {/* Main Section */}
        <div className="flex-1 bg-primary p-6">
          {/* Balances */}
          <div className="flex flex-col lg:flex-row justify-between mb-8 gap-4 ">
            <div className="bg-[#134454] p-4 rounded-xl w-full lg:w-1/2 text-center">
              <h2 className="text-lg font-semibold font-serif">
                {translate("Main_Balance")}
              </h2>
              <p className="text-xl font-bold text-green-400 font-serif">
                {balance} {translate("ETB")}
              </p>
            </div>
            <div className="bg-[#134454] p-4 rounded-xl w-full lg:w-1/2 text-center">
              <h2 className="text-lg font-semibold font-serif">
                {translate("Bonus_Balance")}
              </h2>
              {loading ? (
                <p className="text-gray-300">Loading...</p>
              ) : message ? (
                <p className="text-red-400">{message}</p>
              ) : (
                <p className="text-2xl font-bold text-green-400 font-serif">
                  {totalIncome.toFixed(1)}
                  {translate("ETB")}
                </p>
              )}
            </div>
          </div>

          {/* Dynamic Section */}
          <div className="bg-[#134454] p-6 rounded-xl shadow-lg">
            {activeTab === "deposit" && <DepositSection />}
            {activeTab === "withdraw" && <WithdrawSection />}
            {activeTab === "history" && <HistorySection />}
          </div>
        </div>
      </div>
    </>
  );
}

function DepositSection() {
  const [showTelebirrModal, setShowTelebirrModal] = useState(false);
  const [showCBEModal, setShowCBEModal] = useState(false);
  const [amount, setAmount] = useState("");

  const handleChapaPayment = async (title) => {
    // ✅ Get fresh userInfo from localStorage
    const token = localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : null;
    const userInfo = parseJWT(token?.token);

    if (!userInfo?.id || !userInfo?.phone) {
      toast.error("User info not available yet. Please try again.");
      return;
    }
    // console.log("amount :", amount);
    // 1️⃣ Check empty or whitespace
    // ✅ Check if amount is empty
    if (
      amount === "" || // empty
      amount === null || // safety
      amount === undefined || // safety
      isNaN(amount) || // not a number
      Number(amount) <= 0 // zero or negative
    ) {
      toast.error("እባክዎ የተቀማጭ ገንዘብ መጠን ያስገቡ!");

      return;
    }
    const depositAmount = Number(amount);

    if (isNaN(depositAmount)) {
      toast.error("እባክዎ የተቀማጭ ገንዘብ መጠን ያስገቡ!");
      return;
    }

    if (depositAmount < 20) {
      toast.error("ውድ ደንበኛችን ዝቅተኛ ገቢ 20 ብር ነው!");
      return;
    }

    try {
      const orderData = {
        amount: depositAmount,
        userId: userInfo?.id,
        phone_number: userInfo?.phone,
        title,
      };
      //console.log("payment detail : ", orderData);
      toast.info("ክፍያን በማስኬድ ላይ...");

      const res = await axios.post(
        "https://backend.zemedbingo.com/bingo-api/chapaOrder",
        orderData,
      );
      //  console.log("response : ", res);

      if (res.data.success === true && res.data.checkout_url) {
        window.location.replace(res.data.checkout_url);
      } else {
        toast.error("ክፍያውን መፈጸም አልተቻለም! እባክዎ እንደገና ይሞክሩ።");
        // console.error("Unexpected backend response:", res.data);
      }
    } catch (err) {
      // console.error("Payment Error:", err);
      toast.error(err.response?.data?.message || "Error creating payment.");
    }
  };
  const { t: translate } = useTranslation(["WalletPage"]);
  return (
    <div>
      <h3 className="text-xl font-semibold mb-4 font-serif">
        {translate("Deposit")}
      </h3>
      {/* <input
        type="number"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        placeholder={translate("enter_deposit")}
        className="w-full p-2 rounded bg-primary border border-gray-700 focus:outline-none focus:border-blue-400"
      /> */}
      <div className="flex flex-col lg:flex-row gap-4 mt-6">
        {/* <DepositCard
          title={translate("Deposit")}
          fee={translate("Select_payment")}
          onTransfer={() => handleChapaPayment("Chapa")}
        /> */}
        <DepositCard
          title={translate("telebirr")}
          fee={translate("Manual")}
          onTransfer={() => setShowTelebirrModal(true)}
        />
        <DepositCard
          title="CBE Birr"
          fee="CBE Transfer"
          onTransfer={() => setShowCBEModal(true)}
        />
      </div>
      {/* Show Modal */}
      {showTelebirrModal && (
        <TelebirrDepositModal
          onClose={() => setShowTelebirrModal(false)}
          amount={Number(amount)}
        />
      )}
      {showCBEModal && (
        <CBEDepositModal onClose={() => setShowCBEModal(false)} />
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />
    </div>
  );
}

function DepositCard({ title, fee, onTransfer }) {
  const { t: translate } = useTranslation(["WalletPage"]);
  return (
    <div className="bg-primary p-4 rounded-lg flex-1 flex flex-col justify-between items-center hover:bg-[#032c3aff] transition font-serif">
      <p className="text-lg font-semibold">{title}</p>
      <p className="text-sm text-green-400">{fee}</p>
      <button
        type="button"
        onClick={onTransfer}
        className="
    mt-3 px-4 py-2 text-black bg-[#c99510] rounded-lg
    ring-2 ring-[#c99510] ring-offset-2 ring-offset-yellow-100
    animate-pulse
    hover:bg-[#E0AF53]
  "
      >
        {translate("Transfer")}
      </button>
      <Footer />
    </div>
  );
}

function WithdrawSection() {
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);
  const [amount, setAmount] = useState("");
  const [bank, setBank] = useState("");
  const [accountNumber, setAccountNumber] = useState(userInfo?.phone);
  const [accountName, setAccountName] = useState("");
  const [otp, setOtp] = useState("");

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);

  // -------------------------------
  // LISTEN FOR OTP RESPONSE
  // -------------------------------
  useEffect(() => {
    socket.on("withdrawOTPResponse", (data) => {
      if (data.success) {
        setMessage(`OTP sent! (Code: ${data.otp})`);
        setOtp(data.otp); // auto fill OTP like Signup
        setTimer(30);
      } else {
        setMessage(data.message || "ኦቲፒን መላክ አልተሳካም።");
      }
    });

    socket.on("withdrawResponse", (data) => {
      setLoading(false);

      if (data.success) {
        setMessage("የወጭ ጥያቄ በተሳካ ሁኔታ ተልኳል!");
      } else {
        setMessage(data.message || "ወጭ አልተሳካም።");
      }
    });

    return () => {
      socket.off("withdrawOTPResponse");
      socket.off("withdrawResponse");
    };
  }, []);

  // Countdown timer
  useEffect(() => {
    if (timer <= 0) return;
    const countdown = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(countdown);
  }, [timer]);

  // -------------------------------
  // SEND OTP
  // -------------------------------
  const sendOtp = () => {
    if (!accountNumber) {
      setMessage("እባክዎ መጀመሪያ ስልክ ቁጥር ያስገቡ።");
      return;
    }

    setMessage("Sending OTP...");

    socket.emit("sendWithdrawOTP", { phone: userInfo?.phone });
  };

  // -------------------------------
  // SUBMIT WITHDRAW REQUEST
  // -------------------------------
  const sendWithdraw = (e) => {
    e.preventDefault();

    // Required fields
    if (!amount || !bank || !accountNumber || !accountName || !otp) {
      setMessage("ሁሉንም መረጃ ያስገቡ!");
      return;
    }

    // Minimum withdraw
    if (parseInt(amount) < 100) {
      setMessage("ዝቅተኛ የወጭ መጠን 100 ብር ነው።");
      return;
    }

    setLoading(true);
    const payload = {
      amount,
      bank,
      accountNumber,
      accountName,
      otp,
      userId: userInfo?.id,
    };

    socket.emit("withdraw-request", payload);
  };
  const { t: translate } = useTranslation(["WalletPage"]);
  return (
    <div>
      <h3 className="text-xl font-semibold mb-4">{translate("Withdraw")}</h3>

      <form className="space-y-4" onSubmit={sendWithdraw}>
        <input
          type="number"
          placeholder={translate("enter_amount")}
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          className="w-full p-2 rounded bg-primary border border-gray-700 focus:outline-none focus:border-blue-400"
        />

        <select
          value={bank}
          onChange={(e) => setBank(e.target.value)}
          className="w-full p-2 rounded bg-primary border border-gray-700 focus:outline-none focus:border-blue-400"
        >
          <option value=""> {translate("select_bank")}</option>
          <option value="Telebirr">{translate("telebirr")}</option>
          <option value="CBE"> {translate("cbe")}</option>
        </select>

        <input
          type="text"
          value={accountNumber}
          readOnly
          onChange={(e) => setAccountNumber(e.target.value)}
          className="w-full p-2 rounded bg-primary border border-gray-700 focus:outline-none cursor-not-allowed"
        />

        <input
          type="text"
          placeholder={translate("account_holder")}
          value={accountName}
          onChange={(e) => setAccountName(e.target.value)}
          className="w-full p-2 rounded bg-primary border border-gray-700 focus:outline-none focus:border-blue-400"
        />

        <div className="flex gap-2">
          <input
            type="text"
            placeholder="OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="flex-1 p-2 rounded bg-primary border border-gray-700 focus:outline-none focus:border-blue-400"
          />

          <button
            type="button"
            onClick={sendOtp}
            disabled={timer > 0}
            className={`px-4 py-2 rounded-lg text-white ${
              timer > 0
                ? "bg-gray-600 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            {timer > 0
              ? `${translate("resend")} ${timer}s`
              : translate("send_otp")}
          </button>
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-2 rounded-lg font-semibold text-white ${
            loading
              ? "bg-gray-700 cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700"
          }`}
        >
          {loading ? translate("processing") : translate("manual_withdraw")}
        </button>
      </form>

      {message && (
        <p className="text-yellow-300 text-sm mt-3 break-words">{message}</p>
      )}
      <Footer />
    </div>
  );
}

function HistorySection() {
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);
  const [history, setHistory] = useState([]);
  const phone = userInfo?.phone; // Logged-in user's phone number

  const fetchHistory = async () => {
    try {
      const res = await api.get(`/withdrawals/by-phone/${phone}`);
      //  console.log("Withdrawals response:", res.data);

      if (Array.isArray(res.data.withdrawals)) {
        setHistory(res.data.withdrawals);
      } else {
        setHistory([]);
      }
    } catch (error) {
      console.error(
        "❌ Error fetching withdrawal history:",
        error.response?.data || error,
      );
      setHistory([]);
    }
  };

  useEffect(() => {
    if (phone) fetchHistory();
  }, [phone]);
  const { t: translate } = useTranslation(["WalletPage"]);
  return (
    <div>
      <h3 className="text-xl font-semibold mb-4">
        {translate("Transaction_History")}
      </h3>

      <table className="w-full border-collapse border border-gray-700 text-sm">
        <thead>
          <tr className="bg-primary">
            <th className="p-2 border border-gray-500">{translate("Type")}</th>
            <th className="p-2 border border-gray-500">{translate("Date")}</th>
            <th className="p-2 border border-gray-500">
              {translate("Amount")}
            </th>
            <th className="p-2 border border-gray-500">
              {translate("Status")}
            </th>
          </tr>
        </thead>

        <tbody>
          {history.length === 0 ? (
            <tr>
              <td
                colSpan={4}
                className="p-3 text-center text-gray-400 border border-gray-500"
              >
                {translate("No_transactions")}
              </td>
            </tr>
          ) : (
            history.map((item) => (
              <tr key={item.id}>
                <td className="p-2 border border-gray-500 text-center">
                  {translate("Withdraw")}
                </td>
                <td className="p-2 border border-gray-500 text-center">
                  {item.createdAt?.split("T")[0] || "-"}
                </td>
                <td className="p-2 border border-gray-500 text-center">
                  {item.amount}
                </td>
                <td
                  className={`p-2 border border-gray-500 text-center ${
                    item.status === "success"
                      ? "text-green-400"
                      : item.status === "pending"
                        ? "text-yellow-400"
                        : "text-red-400"
                  }`}
                >
                  {item.status}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <Footer />
    </div>
  );
}
